import { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import SensorDoorRoundedIcon from "@mui/icons-material/SensorDoorRounded";

/* Add/remove entries here to add more dashboards to the sidebar later.
   IMPORTANT: `path` must match the route exactly as registered in your
   router (App.js / routes file) — e.g. if your Fall Alarm page is
   registered as <Route path="/fallalarmdashboard">, use that here
   instead of "/", or the active highlight will never match. */
const NAV_ITEMS = [
  { label: "Fall Alarm Dashboard", path: "/fallalarmdashboard", icon: WarningAmberRoundedIcon },
  { label: "Door sensor Dashboard", path: "/dooralarmdashboard", icon: SensorDoorRoundedIcon },
];

const EXPANDED_WIDTH = 232;
const COLLAPSED_WIDTH = 70;

export default function AppSidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory();
  const location = useLocation();

  return (
    <Box
      sx={{
        width: collapsed ? COLLAPSED_WIDTH : EXPANDED_WIDTH,
        flexShrink: 0,
        alignSelf: "stretch",
        background: "#ffffff",
        borderRight: "1px solid #e5e7eb",
        transition: "width 0.2s ease",
        display: "flex",
        flexDirection: "column",
        mt: 1.5,
        borderRadius: "0 12px 0 0",
        overflowX: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: collapsed ? "center" : "space-between",
          p: 1.5,
          borderBottom: "1px solid #e5e7eb",
          minHeight: 56,
        }}
      >
        {!collapsed && (
          <Typography sx={{ fontWeight: 700, fontSize: "0.9rem", color: "#111827",textAlign: "center",flex: 1 }}>
            Dashboards
          </Typography>
        )}
        <IconButton size="small" onClick={() => setCollapsed((c) => !c)}>
          {collapsed ? <MenuRoundedIcon fontSize="small" /> : <CloseRoundedIcon fontSize="small" />}
        </IconButton>
      </Box>

      <List sx={{ py: 1 }}>
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          const button = (
            <ListItemButton
              selected={isActive}
              onClick={() => history.push(item.path)}
              sx={{
                mx: 1,
                mb: 0.5,
                borderRadius: "8px",
                justifyContent: collapsed ? "center" : "flex-start",
                "&.Mui-selected": {
                  background: "#eff6ff",
                  color: "#2563eb",
                  "&:hover": { background: "#eff6ff" },
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: collapsed ? 0 : 1.5,
                  color: isActive ? "#2563eb" : "#6b7280",
                  justifyContent: "center",
                }}
              >
                <Icon fontSize="small" />
              </ListItemIcon>
              {!collapsed && (
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ fontSize: "0.88rem", fontWeight: isActive ? 700 : 500 }}
                />
              )}
            </ListItemButton>
          );

          return collapsed ? (
            <Tooltip key={item.path} title={item.label} placement="right">
              {button}
            </Tooltip>
          ) : (
            <Box key={item.path}>{button}</Box>
          );
        })}
      </List>
    </Box>
  );
}
